var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.40365 7.33335C3.42133 7.33335 3.43685 7.33657 3.45018 7.34193C3.46303 7.34711 3.47708 7.35555 3.49176 7.37024L8.92509 12.8036C9.52035 13.3988 10.4869 13.3988 11.0822 12.8036L16.5155 7.37024C16.5371 7.34871 16.5678 7.33543 16.6036 7.33543C16.6395 7.33543 16.6702 7.34871 16.6918 7.37024C16.7133 7.39176 16.7266 7.4225 16.7266 7.45835C16.7266 7.4942 16.7133 7.52493 16.6918 7.54646L17.0453 7.90002L16.6918 7.54646L11.2584 12.9798C10.5715 13.6667 9.4458 13.6693 8.74803 12.979C8.74775 12.9787 8.74748 12.9784 8.7472 12.9781L3.31553 7.54646C3.29401 7.52494 3.28073 7.4942 3.28073 7.45835C3.28073 7.42539 3.29195 7.39675 3.31049 7.37562C3.35041 7.34128 3.38651 7.33335 3.40365 7.33335Z",
    fill: "#19224C",
    stroke: "#19224C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.3a48b888c83d6a1e695e45dd464a2d77.svg";
export { ForwardRef as ReactComponent };